import React from 'react';
import { Icon } from './Icons.styles';

export const CloseIcon = props => (
	<Icon viewBox="0 0 15 15" {...props}>
		<path
			fill="currentColor"
			fillRule="nonzero"
			d="M9.658 7.74a.331.331 0 0 1 0-.48l5.137-5.137a.74.74 0 0 0 .205-.48.74.74 0 0 0-.205-.479l-.96-.959A.74.74 0 0 0 13.357 0a.622.622 0 0 0-.48.205L7.74 5.342a.331.331 0 0 1-.48 0L2.123.205A.74.74 0 0 0 1.643 0a.74.74 0 0 0-.479.205l-.959.96A.74.74 0 0 0 0 1.643a.74.74 0 0 0 .205.48L5.342 7.26a.331.331 0 0 1 0 .48L.205 12.877a.74.74 0 0 0-.205.48.74.74 0 0 0 .205.479l.96.959a.74.74 0 0 0 .479.205.74.74 0 0 0 .48-.205L7.26 9.658a.331.331 0 0 1 .48 0l5.137 5.137a.74.74 0 0 0 .48.205.74.74 0 0 0 .479-.205l.959-.96a.74.74 0 0 0 .205-.479.74.74 0 0 0-.205-.48L9.658 7.74z"
		/>
	</Icon>
);



// WEBPACK FOOTER //
// ./src/shared/icons/CloseIcon.js